import React from "react";
import PropTypes from "prop-types";

import {
	ReachUsWrapper,
	Header,
	Description,
	Phone,
	PhoneMobile,
} from "./styles";

const ReachUs = (props) => {
	const { header, description, phone } = props;
	return (
		<ReachUsWrapper>
			<Header>{header}</Header>
			<Description
				dangerouslySetInnerHTML={{
					__html: description,
				}}
			/>
			<Phone>{phone}</Phone>
			<PhoneMobile href={`tel:${phone}`}>
				<p>{"Talk to us"}</p>
			</PhoneMobile>
		</ReachUsWrapper>
	);
};

ReachUs.propTypes = {
	header: PropTypes.string.isRequired,
	description: PropTypes.string,
	phone: PropTypes.string.isRequired,
};

ReachUs.defaultProps = {
	header: "",
	description: "",
	phone: "",
};

export default ReachUs;
